import React from 'react';
import tracker from '@src/utils/sensor/apptracker';
import {
  CLICK_PRESET_LINK_IN_DIMENSIONS_POPUP,
  CLICK_PRESET_LINK_IN_METRICS_POPUP,
} from '@src/utils/sensor/track';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import FocusIco from '@icons/analysis.svg';
import Icon from '@ant-design/icons';

const { baseUrl } = window.conviva;
type presetLinkFromTypes = 'metrics' | 'dimensions';

const handlePresetLinkClick = (linkFrom: presetLinkFromTypes, presetName) => {
  let eventName;
  switch (linkFrom) {
    case 'metrics': {
      eventName = CLICK_PRESET_LINK_IN_METRICS_POPUP;
      break;
    }
    case 'dimensions': {
      eventName = CLICK_PRESET_LINK_IN_DIMENSIONS_POPUP;
      break;
    }
    default: {
      break;
    }
  }
  tracker(eventName, { presetName });
};

type BaseProps = {
  shortcutType: string;
  linkFrom: presetLinkFromTypes;
};

type PresetProps = {
  shortcutType: 'preset';
  preset: any;
};

type FlowPresetProps = {
  shortcutType: 'flow-preset';
  categoryKey: string;
};

type PresetShortcutProps = BaseProps & (PresetProps | FlowPresetProps);

const PresetShortcut: React.FC<PresetShortcutProps> = (props) => {
  const { shortcutType, linkFrom } = props;

  let presetLink, linkTooltip;

  switch (shortcutType) {
    case 'preset': {
      const preset = props.preset;

      presetLink = (
        <Link
          to={`${baseUrl}/dashboard/preset/${preset.key}`}
          onClick={() => handlePresetLinkClick(linkFrom, preset.name)}
        >
          <Icon component={FocusIco} style={{ fontSize: 16 }} />
        </Link>
      );

      linkTooltip = `${preset.description}`;
      break;
    }

    case 'flow-preset': {
      const categoryKey = props.categoryKey;

      presetLink = (
        <Link
          to={`${baseUrl}/dashboard/preset/flow/${categoryKey}`}
          onClick={() => handlePresetLinkClick(linkFrom, `flow-${categoryKey}`)}
        >
          <Icon component={FocusIco} />
        </Link>
      );

      linkTooltip = 'Preset restricted to Global and Flow metrics & metadata';
      break;
    }
  }

  return (
    <Tooltip placement="top" title={linkTooltip}>
      {presetLink}
    </Tooltip>
  );
};

export default PresetShortcut;
